/* eslint-disable no-undef */
export default {
	name: "product-select-collection-order",
	props: ["depotId"],
	emits: ["productSelected"],
	data() {
		return {
			products: [],
			productHeadings: [
				{
					text: "Product",
					field: "product"
				},
				{
					text: "Price",
					field: "price"
				},
				{
					text: "Discounted Amount",
					field: "discountAmountAsString"
				},
				{
					text: "Price After Discount",
					field: "priceAfterDiscountAsString"
				},
				{
					text: "Quantity",
					field: "quantity"
				}
			],
			pagingDetails:{
				pageNumber: 1,
				pageSize: 100,
				totalPages: 1
			},
			filter:{
				searchQuery: null,
				customerSearchQuery: null,
				activeOrInactiveItems: 1
			},
			orderTotal: 0,
			orderTotalAsString: null,
			newAssignedCustomers: [],
			newUnassignedCustomers: [],
			modalHeading: null,
			modalComponentId: null,
			formIsSaving: false,
			showSuccessMessage: false,
			successMessage: null,
			showErrorMessage: false,
			errorMessage: null,
			loading: false
		};
	},
	methods: {
		getDepotProducts(){
			this.loading = true;
			let request = {
				searchQuery: this.filter.customerSearchQuery,
				depotId: this.depotId,
				pageNumber: this.pagingDetails.pageNumber,
				pageSize: this.pagingDetails.pageSize
			};
			orderService.getOrderCollectionProductPricesForDepot(request).then(
				successResponse => {
					let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
					if(isSuccess){
						this.products = successResponse.data.result;
						this.products = dataTableHelper.castFieldValues(this.products);
						for(let i = 0; i < this.products.length; i++){
							this.products[i].errorMessage = null;
							this.products[i].priceAsString = currencyHelper.numberToCurrency(this.products[i].price);
							this.products[i].quantity = 1;
							this.products[i].discountedAmountTotal = 0;
							this.products[i].discountAmountAsString = null;
							this.products[i].priceAfterDiscount = null;
							this.products[i].priceAfterDiscountAsString = null;
							this.products[i].totalAfterDiscount = null;
							this.products[i].totalAfterDiscountAsString = null;
							this.products[i].discountAmount = null;
							// if(this.products[i].discountAmount !== null && this.products[i].discountAmount > 0){
							// 	this.products[i].discountedAmountTotal = this.products[i].quantity * this.products[i].discountAmount;
							// 	this.products[i].discountAmountAsString = currencyHelper.numberToCurrency(this.products[i].discountAmount);
							// 	this.products[i].priceAfterDiscount = this.products[i].basePrice - this.products[i].discountAmount;
							// 	this.products[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.products[i].priceAfterDiscount);
							// 	this.products[i].totalAfterDiscount = this.products[i].quantity * this.products[i].priceAfterDiscount;
							// 	this.products[i].totalAfterDiscountAsString = currencyHelper.numberToCurrency(this.products[i].totalAfterDiscount);
							// }
							this.products[i].total = this.products[i].quantity * this.products[i].price;
							this.products[i].totalAsString = currencyHelper.numberToCurrency(this.products[i].total);
							this.products[i].selected = false;
						}
						console.log("products", this.products);
					}
					this.loading = false;
				},
				errorResponse => {
					console.log("errorResponse", errorResponse);
					apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
					this.loading = false;
				}
			);
		},
		onFilterSearchClicked(){
			this.getDepotProducts()
		},
		onQuantityInput(product){
			console.log("product.selected", product.selected);
			product.selected = true;
			product.errorMessage = null;
			//this.hasError = false;
			if(product.quantity === null || product.quantity === ""){
				product.errorMessage = "Quantity is required";
				//this.hasError = true;
			}
			else if(product.quantity <= 0){
				product.quantity = 1;
			}
			
			product.total = product.quantity * product.price;
			product.totalAsString = currencyHelper.numberToCurrency(product.total);
			if(product.discountAmount !== null && product.discountAmount > 0){
				product.discountedAmountTotal = currencyHelper.roundToTwoDecimalPlaces(product.quantity * product.discountAmount);
				product.totalAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(product.quantity * product.priceAfterDiscount);
				product.totalAfterDiscountAsString = currencyHelper.numberToCurrency(product.totalAfterDiscount);
			}
			this.onProductSelect(product, false);
			this.calculateGrandTotalForOrder();
		},
		calculateGrandTotalForOrder(){
			this.orderTotal = 0;
			for(let i = 0; i < this.products.length; i++){
				if(this.products[i].selected){
					if(this.products[i].discountAmount !== null && this.products[i].discountAmount > 0){
						this.orderTotal += this.products[i].totalAfterDiscount;
					}
					else {
						this.orderTotal += this.products[i].total;
					}
					this.orderTotal = currencyHelper.roundToTwoDecimalPlaces(this.orderTotal);
				}
			}
			this.orderTotalAsString = currencyHelper.numberToCurrency(this.orderTotal);
		},
		onProductSelect(product, canGetDiscount = true){
			let productsToOrder = {
				selectedProducts: [],
				hasError: false
			};
			for(let i = 0; i < this.products.length; i++){
				if(this.products[i].selected){
					if(this.products[i].errorMessage !== null){
						productsToOrder.hasError = true;
					}
					productsToOrder.selectedProducts.push(this.products[i]);
				}
				else{
					this.products[i].selected = false;
					this.products[i].errorMessage = null;
					this.products[i].quantity = 1;
					this.products[i].total = this.products[i].quantity * this.products[i].price;
					this.products[i].totalAsString = currencyHelper.numberToCurrency(this.products[i].total);
				}
			}
			if(canGetDiscount){
				product.loading = true;
				orderService.getDiscountForCompanyAndProduct(product.productId, this.depotId).then(
					successResponse => {
						let isSuccess = apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseStatus(successResponse.data.responseStatus, successResponse.data.httpStatusCode, successResponse.data.message);
						if(isSuccess){
							let response = successResponse.data;
							let selectedProducts = [];
							console.log("product", product);
							if(response.hasDiscountAmount){
								product.discountAmount = response.discountAmount;
								product.discountedAmountTotal = currencyHelper.roundToTwoDecimalPlaces(product.quantity * product.discountAmount);
								product.discountAmountAsString = currencyHelper.numberToCurrency(product.discountAmount);
								product.priceAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(product.price - product.discountAmount);
								product.priceAfterDiscountAsString = currencyHelper.numberToCurrency(product.priceAfterDiscount);
								product.totalAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(product.quantity * product.priceAfterDiscount);
								product.totalAfterDiscountAsString = currencyHelper.numberToCurrency(product.totalAfterDiscount);
							}
							// for(let i = 0; i < this.products.length; i++){
							// 	if(this.products[i].selected){
							// 		// if(this.products[i].productId === response.productId && response.hasDiscountAmount) {
							// 		// 	this.products[i].discountAmount = response.discountAmount;this.products[i].discountedAmountTotal = currencyHelper.roundToTwoDecimalPlaces(this.products[i].quantity * this.products[i].discountAmount);
							// 		// 	this.products[i].discountAmountAsString = currencyHelper.numberToCurrency(this.products[i].discountAmount);
							// 		// 	this.products[i].priceAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(this.products[i].price - this.products[i].discountAmount);
							// 		// 	this.products[i].priceAfterDiscountAsString = currencyHelper.numberToCurrency(this.products[i].priceAfterDiscount);
							// 		// 	this.products[i].totalAfterDiscount = currencyHelper.roundToTwoDecimalPlaces(this.products[i].quantity * this.products[i].priceAfterDiscount);
							// 		// 	this.products[i].totalAfterDiscountAsString = currencyHelper.numberToCurrency(this.products[i].totalAfterDiscount);
							// 		// 	break;
							// 		// }
							// 		// else{
							// 		// 	this.products[i].discountAmount = null;
							// 		// 	this.products[i].discountedAmountTotal = 0;
							// 		// 	this.products[i].discountAmountAsString = null;
							// 		// 	this.products[i].priceAfterDiscount = null;
							// 		// 	this.products[i].priceAfterDiscountAsString = null;
							// 		// 	this.products[i].totalAfterDiscount = null;
							// 		// 	this.products[i].totalAfterDiscountAsString = null;
							// 		// }
							// 		if(this.products[i].errorMessage !== null){
							// 			productsToOrder.hasError = true;
							// 		}
							// 		productsToOrder.selectedProducts.push(this.products[i]);
							// 	}
							// 	else{
							// 		this.products[i].errorMessage = null;
							// 		this.products[i].quantity = 1;
							// 		this.products[i].total = this.products[i].quantity * this.products[i].price;
							// 		this.products[i].totalAsString = currencyHelper.numberToCurrency(this.products[i].total);
							// 	}
							// }
							this.$emit("productSelected", productsToOrder);
							this.calculateGrandTotalForOrder();
						}
						product.loading = false;
					},
					errorResponse => {
						console.log("errorResponse", errorResponse);
						apiResponseHandlerHelepr.displaySessionExpiredMessage(errorResponse.response.status);
						product.loading = false;
					}
				);
			}
			else{
				this.$emit("productSelected", productsToOrder);
				this.calculateGrandTotalForOrder();
			}
			// this.orderTotal = 0;
			// let selectedProducts = [];
			// for(let i = 0; i < this.products.length; i++){
			// 	if(this.products[i].selected){
			// 		if(this.products[i].discountAmount !== null && this.products[i].discountAmount > 0){
			// 			this.products[i].totalAfterDiscount = this.products[i].quantity * this.products[i].priceAfterDiscount;
			// 			this.orderTotal += this.products[i].totalAfterDiscount;
			// 		}
			// 		else{
			// 			this.orderTotal += this.products[i].total;
			// 		}
			// 		this.orderTotal = currencyHelper.roundToTwoDecimalPlaces(this.orderTotal);
			// 		this.products[i].total = currencyHelper.roundToTwoDecimalPlaces(this.products[i].quantity * this.products[i].basePrice);
			// 		selectedProducts.push(this.products[i]);
			// 	}
			// }
			// this.orderTotalAsString = currencyHelper.numberToCurrency(this.orderTotal);
			// this.$emit("productSelected", selectedProducts);
		}
	},
	mounted: function () {
	},
	watch:{
		depotId: {
			handler: function () {
				if(this.depotId !== null){
					this.getDepotProducts();
				}
			},
			immediate: true,
			deep: true
		}
	}
};
